import Button from 'mcs-toolkit/components/Button';
import PropTypes from 'prop-types';
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { metrics as ms } from 'system/libs/metrics';

import Dialog from 'reactApp/components/dialog/Dialog';

export class ConfirmDialog extends React.PureComponent {
    static propTypes = {
        request: PropTypes.func,
        title: PropTypes.string,
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    };

    state = {
        isRequesting: false,
        isOpened: true,
    };

    componentDidMount() {
        const { metrics } = this.props;
        if (metrics?.open) {
            ms.send({
                action: metrics.open,
            });
        }
    }

    _handleClose = () => {
        if (!this.state.isRequesting) {
            const { metrics } = this.props;
            if (metrics?.close) {
                ms.send({
                    action: metrics.close,
                });
            }
            this._close();
        }
    };

    _close = () => {
        // need this to avoid Warning: Can't call setState (or forceUpdate) on an unmounted component
        this.setState(
            {
                isOpened: false,
            },
            () => {
                setTimeout(() => {
                    _removeDialog();
                }, 0);
            },
        );
    };

    _handleAccept = async () => {
        if (this.state.isRequesting) {
            return;
        }
        this.setState({
            isRequesting: true,
        });

        const { metrics } = this.props;
        try {
            await this.props.request(this._close);
            if (metrics?.accept) {
                ms.send({
                    action: metrics.accept,
                });
            }
        } catch (error) {
            if (metrics?.error) {
                ms.send({
                    action: metrics.error,
                });
            }
        }

        this.setState({
            isRequesting: false,
        });
    };

    render() {
        const {
            title = 'Подтвердите действие',
            text = 'Вы уверены?',
            confirmButtonText = 'Подтвердить',
            cancelButtonText = 'Отмена',
            size,
        } = this.props;

        return (
            <Dialog
                onCancel={this._handleClose}
                open={this.state.isOpened}
                header={title}
                size={size}
                footer={
                    <>
                        <Button
                            primary
                            onClick={this._handleAccept}
                            disabled={this.state.isRequesting}
                            loading={this.state.isRequesting}
                            data-test="confirm-button"
                        >
                            {confirmButtonText}
                        </Button>
                        {cancelButtonText && (
                            <Button
                                disabled={this.state.isRequesting}
                                onClick={this._handleClose}
                                data-test="cancel-button"
                            >
                                {cancelButtonText}
                            </Button>
                        )}
                    </>
                }
            >
                {text}
            </Dialog>
        );
    }
}

const _removeDialog = () => {
    const target = document.querySelector('#react-confirm-alert');
    unmountComponentAtNode(target);
    target.parentNode.removeChild(target);
};

const confirm = ({ title, text, request, ...other }) => {
    const divTarget = document.createElement('div');
    divTarget.id = 'react-confirm-alert';
    document.body.appendChild(divTarget);
    render(
        <ConfirmDialog {...{ title, text, request, ...other }} />,
        divTarget,
    );
};

export const Confirmator = {
    confirm,
};
